import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "hotel/briefs";

class HotelBriefService {
  getBriefs(params = {}) {
    return axios.get(ENDPOINT_URL, { headers: authHeader(), params });
  }

  updateStatus(id, status) {
    return axios.patch(
      `${ENDPOINT_URL}/${id}`,
      { status },
      { headers: authHeader() },
    );
  }

  acceptTrainingSuggestion(id) {
    return axios.post(
      `${ENDPOINT_URL}/${id}/accept-training-suggestion`,
      {},
      { headers: authHeader() },
    );
  }
}

export default new HotelBriefService();
